import { Button, Col, Form, Row, Select, Switch } from 'antd';
import { CardHolderType } from 'interfaces/card-holder';
import React, { useState } from 'react';
import { FirstStepFormInputs, FirstStepProps } from './types/firstStepTypes';



const FirstStep: React.FC<FirstStepProps> = ({ goToNext, setFirstStepData, firstStepData, setSecondStepData }) => {
  const [form] = Form.useForm();
  const [validateIdentification, setValidateIdentification] = useState(false)
  const [validateAddress, setValidateAddress] = useState(false);

  const onSubmit = (data: FirstStepFormInputs) => {
    data.validateIdentification = validateIdentification;
    data.validateAddress = validateAddress;
    if (firstStepData && data.cardHolderType !== firstStepData.cardHolderType) {
      setSecondStepData(null);
    }
    setFirstStepData(data);
    goToNext();
  };

  return (
    <Row>
      <Col span={24}>
        <Form<FirstStepFormInputs>
          layout="horizontal"
          onFinish={onSubmit}
          initialValues={firstStepData || undefined}
          form={form}
          style={{ width: 'max-content', minWidth: '420px', maxWidth: '100%', margin: 'auto' }}
        >
          <Form.Item<FirstStepFormInputs>
            label="Tipo de Titular"
            name="cardHolderType"
            rules={[{ required: true, message: 'Por favor selecciona una opcion.' }]}
          >
            <Select
              placeholder="Seleccionar"
              options={[
                {
                  label: 'Persona',
                  value: CardHolderType.Person,
                },
                {
                  label: 'Compañia',
                  value: CardHolderType.Company,
                },
              ]}
            >
              <Select.Option value="demo">Demo</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item<FirstStepFormInputs>
            label="Tipo de Balance"
            name="centralized"
            rules={[{ required: true, message: 'Por favor selecciona una opcion.' }]}
          >
            <Select
              placeholder="Seleccionar"
              options={[
                {
                  label: 'Centralizado',
                  value: 'true',
                },
                {
                  label: 'Descentralizado',
                  value: 'false',
                },
              ]}
            />
          </Form.Item>
          <Form.Item<FirstStepFormInputs>
            label="Validar Identificacion"
            name="validateIdentification"
            labelAlign="left"
          >
            <Switch value={validateIdentification} onChange={() => setValidateIdentification(!validateIdentification)} />
          </Form.Item>
          <Form.Item<FirstStepFormInputs>
            label="Validar Direccion"
            name="validateAddress"
          >
            <Switch value={validateAddress} onChange={() => setValidateAddress(!validateAddress)} />
          </Form.Item>
          <Form.Item style={{ textAlign: 'center' }}>
            <Button htmlType="submit" type="primary">
              Siguiente
            </Button>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default FirstStep;
